import React from 'react';
import { useMediaQuery } from '@mui/material';
import useZoomDetection from './useZoomDetection';

/**
 * Hook personalizado que diferencia entre dispositivos móveis reais e zoom no desktop
 * Resolve o problema do menu lateral desaparecer quando se faz zoom na tela
 */
const useResponsiveBreakpoint = () => {
    const isNotMobile = useMediaQuery('(min-width:1200px)');
    const { isZoomed } = useZoomDetection();
    
    // Detecta se é um dispositivo mobile real
    const isTouchDevice = React.useMemo(() => {
        if (typeof window === 'undefined') return false;
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }, []);
    
    // Usa um breakpoint mais baixo para dispositivos realmente móveis
    const isActuallyMobile = useMediaQuery('(max-width:768px)');
    
    // Só considera como mobile se for realmente um dispositivo móvel OU uma tela muito pequena
    // Se estiver com zoom em um desktop, não considera como mobile
    const isMobileContext = React.useMemo(() => {
        // Se é um dispositivo touch real e uma tela pequena
        if (isActuallyMobile && isTouchDevice) return true;
        
        // Se não é mobile pelo breakpoint grande mas também não é zoom em desktop
        if (!isNotMobile && isTouchDevice && !isZoomed) return true;
        
        return false;
    }, [isActuallyMobile, isNotMobile, isTouchDevice, isZoomed]);

    return {
        isNotMobile,
        isTouchDevice,
        isActuallyMobile,
        isMobileContext,
        isZoomed,
        // Para compatibilidade com código existente
        isDesktop: !isMobileContext
    };
};

export default useResponsiveBreakpoint;
